export default __webpack_public_path__ + "static/media/NR.fef37c6d.svg";